export default __webpack_public_path__ + "static/media/job-left-icon.5fec6572.png";